import { ReactElement } from "react";
import ReactMarkdown from "react-markdown";
import { sanitizeLessonText } from "../../utils/sanitizeLessonText";
import { mediaUrlWithCacheBust } from "../../utils/mediaUrl";
import { logLessonMediaLoadFailure } from "../../utils/clientDiagnosticLog";

interface IProps {
  id?: number;
  title?: string;
  content?: string;
  url?: string;
  /** Счётчик принудительного обновления медиа (кнопка на странице урока). */
  cacheBust?: number;
  qwestion?: { q: string; answ?: string[] };
  onClickNextEx: () => void;
}

export function TextImgLesson(props: IProps): ReactElement {
  const safeTitle = sanitizeLessonText(props.title);
  const safeContent = sanitizeLessonText(props.content);
  const imgSrc = mediaUrlWithCacheBust(
    props.url == null || props.url === "" ? "" : props.url.startsWith("/") ? props.url : `/${props.url}`,
    props.cacheBust ?? 0
  );
  return (
    <>
      <div className="lessonPageConteinerImgText">
        <img
          className="textConteiner-img"
          src={imgSrc}
          alt="lesson"
          onError={() =>
            logLessonMediaLoadFailure({
              kind: "image",
              src: imgSrc,
              exerciseId: props.id,
            })
          }
        />
        <div className="textConteiner textImgLesson">
          <h2>{safeTitle}</h2>
          <ReactMarkdown>{safeContent}</ReactMarkdown> 
        </div>
      </div>
      <div className="lessonPageOnward-button" onClick={() => props.onClickNextEx()}>
        Далее
      </div>
    </>
  );
}
